import React, { Component } from "react"
import config from "react-global-configuration"
import FaqElement from "./FaqElement"
import * as tracking from "../../helpers/tracking"

class FaqTop3 extends Component {
  render() {
    const textKeys = config.get("faq.general") || {}

    const faqContent = this.props.faqContent || []

    if (!faqContent || faqContent.length === 0) return null

    return (
      <section className="deck deck--static deck--padding-top deck--padding-bottom no-print">
        <div className="w--wider">
          <div className="accordion__wrapper">
            <header className="accordion__header">
              <h4>{textKeys.title || "Ofte stillede spørgsmål"}</h4>
              <a
                className="button button--link has-icon"
                href={textKeys.link || "#"}
                onClick={() => tracking.trackParkingFlowClick("faq", "read more questions", this.props)}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--arrowright">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright">
                      &nbsp;
                    </use>
                  </svg>
                </span>
                <span className="text">{textKeys.linkLabel || "Se flere spørgsmål og svar"}</span>
              </a>
            </header>

            {faqContent.map((faq, index) => (
              <FaqElement faqElementContent={faq} key={index} {...this.props} />
            ))}
            <footer className="accordion__footer">
              <a className="button button--link has-icon" href={textKeys.link || "#"}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--arrowright">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright">
                      &nbsp;
                    </use>
                  </svg>
                </span>
                <span className="text">{textKeys.linkLabel || "Se flere spørgsmål og svar"}</span>
              </a>
            </footer>
          </div>
        </div>
      </section>
    )
  }
}

export default FaqTop3
